'use client';

import { c as _c } from "react/compiler-runtime";
import _pick from 'lodash/pick';
import { PrimeReactProvider } from 'primereact/api';
import { usePassThrough } from 'primereact/passthrough';
import Tailwind from 'primereact/passthrough/tailwind';
import classNames from '@/utils/classNames';
const TAILWIND_TREE = {
  root: {
    className: 'max-w-full! text-sm p-0! border-none dark:bg-white! text-greyscale-950 dark:text-greyscale-950! dark:border-gray-300!'
  },
  filterContainer: {
    className: 'hidden'
  },
  container: {
    className: 'max-h-80 p-0'
  },
  node: {
    className: 'cursor-pointer px-0!'
  },
  content: {
    className: 'px-2! py-0.5! justify-between'
  },
  subgroup: {
    className: 'pl-6!'
  },
  toggler: {
    className: 'size-4! mr-0! focus:shadow-none! dark:text-greyscale-950! dark:hover:text-greyscale-950! dark:hover:bg-white!'
  },
  togglericon: {
    className: 'size-3! mr-0!'
  },
  checkboxcontainer: {
    className: 'hidden'
  },
  checkbox: ({
    context,
    props
  }) => ({
    className: classNames('hidden', 'h-5! w-5! rounded-md', {
      'bg-blue-500!': context.partialChecked
    })
  }),
  checkboxicon: {
    className: 'w-2.5 h-2.5'
  },
  input: {
    className: 'p-1.5! pl-7! focus:shadow-none! dark:bg-white! text-greyscale-950 dark:text-greyscale-950! rounded-none! border-0 border-b border-stone-200 focus:ring-0'
  },
  searchIcon: {
    className: 'right-0 left-2 -mt-1.5'
  }
};
const TAILWIND_OVERLAY_PANEL = {
  root: {
    className: 'rounded-sm! border! border-stone-200! shadow-dropdown! before:border-none'
  },
  content: {
    className: 'flex! flex-col! items-start! justify-center! p-2! gap-2! bg-white!'
  }
};
const TAILWIND_CHECKBOX = {
  root: {
    className: 'hidden!'
  }
};
const TAILWIND_OVERRIDES = {
  tree: TAILWIND_TREE,
  overlaypanel: TAILWIND_OVERLAY_PANEL,
  checkbox: TAILWIND_CHECKBOX
};
export default function Provider(t0) {
  const $ = _c(7);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = _pick(Tailwind, ["tree", "overlaypanel", "checkbox"]);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      mergeSections: true,
      mergeProps: true,
      classNameMergeFunction: classNames
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const CustomTailwind = usePassThrough(t1, TAILWIND_OVERRIDES, t2);
  let t3;
  if ($[2] !== CustomTailwind) {
    t3 = {
      unstyled: true,
      pt: CustomTailwind
    };
    $[2] = CustomTailwind;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== children || $[5] !== t3) {
    t4 = <PrimeReactProvider value={t3}>{children}</PrimeReactProvider>;
    $[4] = children;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}